<template>
    <div class="bind_gameacc_pop">
        <div class="header">
            账号验证
            <van-icon name="cross" color="#fff" @click="close"/>
        </div>
        <div class="content">
            <p>发送短信至您游戏手机号</p>
            <el-form :model="actionData" ref="form" :rules="rules" @submit.native.prevent>
                <el-form-item prop="code" key="code" :rules="rules.code">
                    <div class="code_area">
                        <el-input
                            v-model="actionData.code"
                            type="number"
                            oninput="if(value.length > 6) value=value.slice(0, 6);"
                            class="lwc_code"
                            placeholder="请输入验证码"
                            ref="code"
                            @input="handleInput"
                        ></el-input>
                        <el-button
                            :class="{ 'lwc_primary': true, 'lwc_disabled': isdisabled }"
                            :disabled="isdisabled"
                            @click="sendCode"
                            >{{ buttonName }}</el-button
                        >
                    </div>
                </el-form-item>
            </el-form>
            <el-button class="confirm" type="primary" @click="bindGameacc" :disabled="actionData.code.length != 6" :loading="loading > 0">确认</el-button>
        </div>        
    </div>
</template>
<script>
export default {
    data() {
        return {
            actionData: {
                code: ''
            },
            rules: {
                code: [
                    { required: true, message: '请输入验证码', trigger: 'blur' }
                ]
            },
            buttonName: '发送验证码',
            isdisabled: false,
            time: 58,
            loading: 0,
        }
    },
    methods: {
        close() {
            this.$emit('closeModal')
        },
        handleInput() {
            this.$refs.form.clearValidate('code')
        },
        sendCode() {
            var that = this;
            that.$refs.code.focus()
            this.isdisabled = true
            this.$Ajax('common/send-code',{
                app_id: this.selection.app_id,
                mobile: this.selection.mobile,
                action: 'bind',
                // account: this.selection.account,
                // platform_id: this.selection.platform_id,
                // user_id: this.selection.user_id,
                // jh_user_id: this.selection.jh_user_id
            }).then(rs => {
                this.$toast({
                  message: rs.msg,
                  zIndex: 100000000,
                });
                if(rs.code == 200) {
                    that.buttonName = "重新获取(59s)";
                    let interval = window.setInterval(function () {
                      that.buttonName = "重新获取(" + that.time + ")s";
                      that.time--;
                      if (that.time < 0) {
                        that.buttonName = "重新获取";
                        that.time = 58;
                        that.isdisabled = false;
                        window.clearInterval(interval);
                      }
                    }, 1000);
                }else {
                    that.buttonName = "重新获取";
                    that.time = 58;
                    that.isdisabled = false;
                }
            })
        },
        bindGameacc() {
            var that = this
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.loading++
                    this.$Ajax('v2/user/mobile-check',{
                        account: this.selection.account,
                        app_id: this.selection.app_id,
                        platform_id: this.selection.platform_id,
                        mobile: this.selection.mobile,
                        user_id: this.selection.user_id,
                        jh_user_id: this.selection.jh_user_id,
                        code: this.actionData.code
                    }).then(rs => {
                        this.$toast({
                            message: rs.msg,
                            zIndex: 100000,
                        });
                        if(rs.code == 200) {
                            this.$emit('closeModal')
                            this.$emit('success',{
                                game_account: rs.data.game_account,
                                account: rs.data.account
                            })
                        }
                    }).finally(() => {
                        setTimeout(() => {
                          that.loading = 0;
                        }, 2000);
                    });
                }
            })
        }
    }
}
</script>
<style lang="less" scoped>
.bind_gameacc_pop {
    .header {
        text-align: center;
        height: 3.6rem;
        line-height: 3.6rem;
        background-color: #F66F30;
        color: #fff;
        position: relative;
        font-size: 1.6rem;
        font-weight: 700;
        .van-icon {
            font-size: 1.6rem;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            right: .8rem;
            cursor: pointer;
        }
    }
    .content {
        padding: 1.6rem 1.5rem 1.9rem;
        p {
            font-size: 1.6rem;
            margin-bottom: 1.5rem;
        }
        .code_area {
            display: flex;
            .lwc_code {
                flex: 1;
                height: 4rem;
                font-size: 1.3rem;
                
                /deep/.el-input__inner {
                    height: 4rem;
                    border: none;
                    outline: none;
                    border-radius: 1rem;
                    background-color: #f5f5f5;
                    &:focus {
                        border: none;
                    }
                }
            }
            .lwc_primary {
                width: 10.6rem;
                height: 4rem;
                background-color: #FFEFE4;
                color: #F66F30;
                font-size: 1.3rem;
                margin-left: .8rem;
                border-radius: 1rem;
                border: none;
                outline: none;
                &:disabled {
                    background-color: #f5f5f5;
                    color: #ACACAC;
                    opacity: 1;
                }
            }
        }
        .confirm {
            width: 100%;
            height: 3.2rem;
            background-color: #F66F30;
            color: #fff;
            font-size: 1.6rem;
            border-radius: 10rem;
            border: none;
            outline: none;
            &:disabled {
                background-color: #999;
                opacity: 1;
            }
        }
    }
}
</style>

